<template>
  <form
    class="px-11 pt-15 pb-48 flex flex-col space-y-15"
    autocomplete="off"
  >
    <resultats
      :data-to-show="isResultsPopupDisplayed"
      :results="listNominees"
      @showChange="
        (val) => {
          isResultsPopupDisplayed = val;
        }
      "
    />
    <competences-personnelles />

    <competences-socio-pro />

    <competences-professionnelles />

    <div class="flex flex-col items-center justify-center space-y-5">
      <action-button
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-pink-600"
        bg-color-square="bg-pink-600"
        icon-color="text-white"
        libelle="Rechercher"
        :uppercase="true"
        icon="arrow-right_1"
        type-shadow="shadow-pink"
        :right="true"
        @clickAction="search"
      />
      <div
        v-if="error"
        class="text-sm text-pink-600 flex justify-center"
      >
        {{ errorMsg }}
      </div>
    </div>
  </form>
</template>

<script>
import CompetencesPersonnelles from './components/CompetencesPersonnelles.vue';
import CompetencesSocioPro from './components/CompetencesSocioPro.vue';
import CompetencesProfessionnelles from './components/CompetencesProfessionnelles.vue';
import Resultats from './popup/Resultats.vue';

import ActionButton from './../../components/ActionButton.vue';

import axios from './../../api';
import { mapGetters } from 'vuex';

export default {
  name: 'SearchBySkills',

  components: {
    CompetencesPersonnelles,
    CompetencesSocioPro,
    CompetencesProfessionnelles,
    ActionButton,
    Resultats,
  },

  data() {
    return {
      isResultsPopupDisplayed: false,
      listNominees: [],
      errorMsg: '',
    };
  },

  methods: {
    search() {
      this.errorMsg = '';
      axios
        .post('api/recherche/searching', this.searching)
        .then((response) => {
          console.log('list nominees', response.data);
          this.listNominees = response.data;
          this.isResultsPopupDisplayed = true;
        })
        .catch((err) => {
          console.log(err.response.data);
          this.errorMsg = err.response.data;
        });
    },
  },

  computed: {
    ...mapGetters({
      searching: 'rechercheCompetences/searching',
    }),

    error() {
      return !!this.errorMsg;
    }
  },
};
</script>